import axios from 'axios';
import { NewUser } from '@/features/auth/internal/types/new-user';
import { emitGTMEvent } from '@/features/gtm/shared/helper/emit-gtm-event';
import { getLocaleFromPathname } from '@/shared/utils/i18n/locale-path';

export async function signUpUser(newUser: NewUser): Promise<void> {
  const locale = getLocaleFromPathname(window.location.pathname);
  const { campaignId, returnTo, ...rest } = newUser;
  const result = await axios.post(
    '/api/auth/signup',
    { ...rest, locale, ...(campaignId ? { campaignId } : {}), ...(returnTo ? { returnTo } : {}) },
    {
      headers: { 'Content-Type': 'application/json' },
    },
  );

  const umsGuid = result.data.umsGuid;
  emitGTMEvent('USER_SIGNUP', { ums: umsGuid });
}
